import React from "react";
import MotionAfterHydration from "../MotionAfterHydration";

export default function Reveal({ children, className = "", delay = 0 }) {
  return (
    <MotionAfterHydration
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.45, ease: "easeOut", delay }}
    >
      {children}
    </MotionAfterHydration>
  );
}
